import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { FormInput } from "../../components/forms/form-input";
import { isNull } from "../../_helpers/isNull";
import { AppAlert } from "../../components/utils/alert";
import { LoadingIndicator } from "../../components/utils/loader";
import { ellipsizetext } from "../../_helpers/ellipsize";
import { FooterComponent } from "../../components/footer/footer";
import { useProduct } from "../../services/products/product.context";

export const OrderPage = () => {

    const { products, total } = useLocation().state;

    const { orderProducts, loading } = useProduct();

    const [orderData, setOrderData] = useState({
        names: '',
        email: '',
        address: '',
        phoneNumber: '',
        city: '',
        region: '',
        productList: [],
        total
    });
    const [onAlert, setOnAlert] = useState();

    const { names, email, address, phoneNumber, city, region } = orderData;

    const handleInput = (e) => {
        setOrderData((d) => ({ ...d, [e.target.name]: e.target.value }));
    }

    const handleSubmitData = async () => {
        const allKeys = Object.keys(orderData);
        if (allKeys.some((key) => isNull(orderData[key]))) {
            setOnAlert({
                caption: 'Invalid input!',
                message: "Please provide all the required data",
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
        console.log(orderData);
        const resp = await orderProducts(orderData);
        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
        setOnAlert({
            caption: 'Success!',
            message: resp?.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert();
                window.location.href = "/categories"
            }
        });
    }

    useEffect(() => {

        const list = products.map((item) => {
            const itemKey = `${item.quantity} ${item?.designation}`
            return { [itemKey]: item.price }
        });
        setOrderData((d) => ({ ...d, productList: list }))
    }, [products])

    return (
        <div className="page-body">
            <SiteHeader pageTitle={"Order form"} />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    onAcept={onAlert.onAccept}
                    accept={onAlert.accept}
                    onClose={() => setOnAlert()}
                />
            )}
            {loading && <LoadingIndicator />}
            <div className="order-form-container form-container">
                <form
                    className="order-form login-form"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmitData();
                    }}
                >
                    <div className="order-details">
                        <div className="bill-caption">Bill details</div>
                        <div className="price-list">
                            {products?.map((product, k) => (
                                <div className="order-list-unit" key={k}>
                                    <div className="product-des">{product?.quantity}</div>
                                    <div className="product-des">{ellipsizetext(product?.designation)}</div>
                                    <div className="product-price">{product?.price}</div>
                                </div>
                            ))}
                        </div>
                        <div className="order-list-unit">
                            <div className="product-des">Total:</div>
                            <div className="product-price total">{total}</div>
                        </div>
                    </div>
                    <FormInput
                        type={"text"}
                        name={"names"}
                        value={names}
                        onChange={(e) => handleInput(e)}
                        label={"Names e.g. John Doe"}
                        required={true}
                    />
                    <FormInput
                        type={'email'}
                        name={'email'}
                        value={email}
                        onChange={(e) => handleInput(e)}
                        required={true}
                        label={'Email e.g. johndoe@example.com'}
                    />
                    <FormInput
                        type={'text'}
                        name={'address'}
                        value={address}
                        label={'Delivery address (region,city, street)'}
                        required={true}
                        onChange={(e) => handleInput(e)}
                    />
                    <FormInput
                        type={'text'}
                        name={'city'}
                        value={city}
                        label={'City of delivery'}
                        required={true}
                        onChange={(e) => handleInput(e)}
                    />
                    <FormInput
                        type={'text'}
                        name={'region'}
                        value={region}
                        label={'Region'}
                        required={true}
                        onChange={(e) => handleInput(e)}
                    />
                    <FormInput
                        type={'tel'}
                        name={'phoneNumber'}
                        value={phoneNumber}
                        label={'Phone number plus country code'}
                        required={true}
                        onChange={(e) => handleInput(e)}
                    />

                    <div
                        className="order-button-box"
                        onClick={async (e) => {
                            e.preventDefault();
                            await handleSubmitData();
                        }}
                    >
                        <button className="final-order-button">Submit Order</button>
                    </div>

                </form>
            </div>
            <FooterComponent />
        </div>
    )
}